
export default (store) => ({
  path: 'splash',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Splash = require('./containers/SplashContainer').default

      /*  Return getComponent   */
      cb(null, Splash)

    /* Webpack named bundle   */
    }, 'Splash')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/Splash/index.js
 **/